"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoutePublic = void 0;
const isRoutePublic = (pathname) => [
    '/',
    '/login',
    '/login-falhou',
    '/esqueci-minha-senha',
    '/nao-encontrado',
    '/error',
    '/conta-bloqueada',
    '/escolha-estado',
    '/minha-loja-desativada',
].some((item) => item === pathname);
exports.isRoutePublic = isRoutePublic;
